import React from 'react'
import { Grid, Theme, Button } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import { CategoryModifications } from '@src/types/graphql-types'
import messages from '@src/routes/Configurators/messages'
import { InsertModificationArgs } from '../../ProductsConfiguration'

interface BaseModificationsProps {
  disabled: boolean
  degenerateBase: CategoryModifications
  insertModificationIntoSequence: ({
    value,
    resetMod,
    isAntiSense,
  }: InsertModificationArgs) => Promise<string>
  isAntiSense?: boolean
}
const useStyle = makeStyles((theme: Theme) => {
  return {
    addButton: {
      minWidth: 'auto',
      padding: theme.spacing(0),
      fontWeight: theme.typography.fontWeightBold,
    },
  }
})
const BaseModificationSingle: React.FC<BaseModificationsProps> = ({
  disabled,
  degenerateBase,
  insertModificationIntoSequence,
  isAntiSense,
}) => {
  const classes = useStyle()
  const intl = useIntl()
  const onClick = () => {
    insertModificationIntoSequence({
      value: degenerateBase.value,
      isAntiSense,
    })
  }
  return (
    <Grid container alignItems="center" style={{ marginTop: '8px' }}>
      <Grid item xs={9}>
        {degenerateBase?.displayName
          ? intl.formatMessage({
              id: degenerateBase.displayName,
              defaultMessage:
                messages[degenerateBase.displayName]?.defaultMessage ||
                degenerateBase.name,
            })
          : degenerateBase?.name}
      </Grid>
      <Grid item xs={3}>
        <Button
          color="primary"
          variant="text"
          size="small"
          className={classes.addButton}
          onClick={onClick}
          disabled={disabled}
        >
          <FormattedMessage
            id="LAB_WATER_STEP_SIX_ADD_V2"
            defaultMessage="Add"
          />
        </Button>
      </Grid>
    </Grid>
  )
}

export default BaseModificationSingle
